import _ from "lodash";
import { PianoRollCoordinates } from "../components/rolls/VisualSelection";
import { ContainerAtom, HorizontalNoteContainer } from "../model/containers";
import { SelectionGeometry } from "./NoteSelectionGroup";
import { Note } from "../model/core";


type SelectionStateMachine = 'IDLE' | 'SELECTING' | 'COMMITTED';

export type Selection = {
    state: SelectionStateMachine,
    start: PianoRollCoordinates,
    end: PianoRollCoordinates,
    startX: number,
    startY: number,
    endX: number,
    endY: number,
};

export function calculateSelectedNotes(
    hnc: HorizontalNoteContainer,
    selectionCoordinates: SelectionGeometry,
    selection: Selection
) : { start: number, note: ContainerAtom<Note> }[] {
    const left = selection.start.start < selection.end.start ? selection.start : selection.end;

    const notes = hnc.search(left.start, selectionCoordinates.width + left.start)
        .filter(n => n.payload.index >= selectionCoordinates.top - selectionCoordinates.height
            && n.payload.index <= selectionCoordinates.top)
        .map(n => { return { start: n.step, note: n }; });

    return notes;
}